import { Box, styled } from '@mui/material';

const Container = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  height: '100%',
  justifyContent: 'space-around',
}));

const HeaderRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const InfoRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
}));

const ContactSection = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}));

const CategoryBadge = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(0.25),
  padding: `${theme.spacing(0.25)} ${theme.spacing(1)}`,
  backgroundColor: '#E8F3FC',
  color: theme.palette.primary.main,
  borderRadius: theme.spacing(1),
  fontSize: '0.875rem',
  display: 'inline-flex',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  maxWidth: '100px',
}));

const SalesRepBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const StyledLinkSpan = styled('span')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '0.95rem',
  color: theme.palette.primary.main,
  cursor: 'pointer',
}));

const ContactCardsRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1),
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export { Container, HeaderRow, InfoRow, ContactSection, ContactCardsRow, CategoryBadge, SalesRepBox, StyledLinkSpan };
